
        import '/home/builduser/work/c1dd1064fea009a6/santa-editor/packages/animations/globalAnimationsPanel/globalAnimations.scss.css.virtualfile';
        module.exports = {"animationKitsList":"_animationKitsList_1ny4z_1","animationKitButton":"_animationKitButton_1ny4z_5"};